/* eslint import/prefer-default-export: 0 */

const OPTIONS = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Id-Type': 'String'
  }
};

export function requestPromoPage(promoUrl) {
  return fetch(`/ui/api/v1/cms/content?urlSegment=${promoUrl}&contentType=LandingPage`, OPTIONS)
    .catch(e => e)
    .then((response) => {
      if (response.ok) {
        return Promise.resolve(response.json());
      }

      return Promise.reject({
        error: 'Promo page request 1 failed. Trying again...'
      });
    })
    .then((json) => {
      if (json.contentlets && json.contentlets.length) {
        const {
          id,
          title,
          subtitle,
          backgroundImage,
          registrationImage,
          videoUrl,
          videoTitle,
          listTitleField1,
          listTitleField2,
          listTitleField3,
          listTitleField4,
          listTitleField5,
          urlSegment,
          description,
          joinButton,
          bonusCode,
          trustPilotWidget,
          termsAndConditions,
          ctaPosition,
          product,
          // contact form fields
          formTitle,
          formBody,
          formFields,
          termsLabel,
          termsDestinationUrl,
          formButtonText,
          zendeskQueue,
        } = json.contentlets[0];

        const payload = {
          id,
          title,
          subtitle,
          backgroundImage: `${window.location.origin}/dA/${backgroundImage}`,
          registrationImage: registrationImage ? `${window.location.origin}/dA/${registrationImage}` : '',
          videoUrl,
          videoTitle,
          listTitleField1,
          listTitleField2,
          listTitleField3,
          listTitleField4,
          listTitleField5,
          bonusCode,
          description,
          joinButton,
          urlSegment,
          trustPilotWidget,
          termsAndConditions,
          ctaPosition,
          product,
          // contact form fields
          formTitle,
          formBody,
          formFields,
          termsLabel,
          termsDestinationUrl,
          formButtonText,
          zendeskQueue,
        };

        return payload;
      }

      return Promise.reject({
        error: 'promo-not-available'
      });
    })
    .catch(e => e);
}
